import { useMutation } from '@apollo/client';
import userPreferences from '../../graphql/userPreferences';

interface UserPreferencesInput {
  user_id: string;
  user_email: string;
  preferences: {
    marketing_subscribed: boolean;
    pltv_analytics_agreed: boolean;
  };
}

const useUpdateUsageAnalyticsPreference = () =>
  useMutation<unknown, { input: UserPreferencesInput }>(userPreferences);

export default useUpdateUsageAnalyticsPreference;
